import { Component, ViewContainerRef } from "@angular/core";
import { NgbModal, NgbActiveModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { QuillModule } from "ngx-quill";
import { SharedData } from "../../shared/sharedData";
import { Configuration } from "../../shared/services/configuration";
import { HttpClientCustom } from "../../shared/services/http.client";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import * as _ from "underscore";
import { ToasterComponent } from "../../toasterComponent/toasterComponent";
import { ScheduleAnnouncement } from "./scheduleAnnouncement";
import { Observable } from "rxjs/Observable";
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from 'rxjs';

@Component({
  selector: "Announcements",
  templateUrl: "announcements.html"
})
export class Announcements {
  public SelectedImgData: any;
  public closeResult: any;
  public selected = [];
  public filteredList = [];
  public query = "";
  public searchKey: any;
  public sendEmail: boolean = false;
  public announcementData = {
    videoURL: [],
    textContent: null,
    attachmentList: [],
    title: null,
    triggerDtm: null
  };

  public safe = true;
  public _baseUrl: any;
  public url;
  public selectEmployeeOption: any = 1;
  public disabledTextarea: any = true;
  public disTextArea: any = true;
  public buttonStatus: any = false;
  public scheduleButton: any = false;
  public validate = 1;
  public payload = {
    programId: null,
    employeeCodes: null,
    participantsType: null
  };
  public showButtonLoading: any = false;
  public empCodeValues: any = "";
  public empCodeList: any = [];
  public searchData = {
    nameOrCodeOrEmail: "",
    employeeCodes: [],
    excludedEmployeeCodes: [],
    includeEmpIds: [],
    excludeEmpIds: [],
    gradeIds: [],
    mgrLevelIds: [],
    designationIds: [],
    categoryIds: [],
    includeOrgIds: [],
    excludeOrgIds: [],
    supervisorIds: [],
    primarySupervisorIds: [],
    primarySupervisorNameOrCode: null,
    primarySupervisorCods: [],
    employeeStatus: null,
    employeesWithOutSupervisor: null,
    scorecardStates: null,
    memberShipState: null,
    programId: null,
    pageSize: 10,
    page: 1,
    fetchSupervisorLevels: 0
  };

  public minStartDate: any = {};
  public img: string;
  public savedImages: any = [];
  public announcementContent: any = [];
  public invalidURL: boolean;
  public videoLink: any;
  public allurl: any = [];
  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    public router: Router,
    public _global: Configuration,
    public http: HttpClientCustom,
    public share: SharedData,
    public _location: Location,
    public translate: TranslateService,
    public _toaster: ToasterComponent,
    public vcr: ViewContainerRef,
    public quill: QuillModule
  ) {
    this._baseUrl = _global.get("EPMS_BASE_URL");
    this._toaster.setViewRef(vcr);
    if (this.share.getMapValues("announcement")) {
      this.announcementData = this.share.getMapValues("announcement");
    }

    if (this.share.getMapValues("allurlImageData")) {
      this.allurl = this.share.getMapValues("allurlImageData");
    }

    if (this.share.getMapValues("videoLink")) {
      this.videoLink = this.share.getMapValues("videoLink");
    }

  }

  public onEmployeeSelectionChange(option) {
    if (option == 1) {
      this.disabledTextarea = true;
      this.disTextArea = true;
    } else if (option == 2) {
      this.disabledTextarea = false;
      this.disTextArea = true;
    } else {
      this.disabledTextarea = false;
      this.disTextArea = false;
      this.share.saveData(this.announcementData);
    }
    this.selectEmployeeOption = option;
  }

  public validateEmps(flag) {
    if (flag == 1) {
      if (!this.getAnnouncementData()) {
        if (this.validateData()) {
          this.triggerAnnouncement();
        }
      }
    } else {
      if (!this.getAnnouncementData()) {
        if (this.validateData()) {
          this.scheduleAnnouncement(this.announcementData);
        }
      }
    }
  }

  public validateData() {
    if (!this.announcementData.title) {
      this.translate.get("enterAnnouncementTitle").subscribe(msg => {
        this._toaster.showError(msg);
      });
      return false;
    }
    return true;
  }

  public select(item) {
    this.selected.push(item);
    this.query = "";
    this.filteredList = [];
  }

  public remove(item) {
    let fList = this.filteredList;
    _.each(fList, function (key, val) {
      if (fList[val].id == item.id) {
        fList[val].checked = false;
      }
    });
    this.filteredList = [];
    this.filteredList = fList;
    this.selected.splice(this.selected.indexOf(item), 1);
  }

  public filter(keyword: any) {
    this.filteredList = [];
    let url = this._baseUrl + "v1/webAdmin/announcement/groupSearch";
    if (keyword.trim()) {
      url += "?searchString=" + keyword;
      this.http.get(url).subscribe(res => {
        this.formatList(res);
      });
    } else {
      this.filteredList = [];
    }
  }

  public formatList(newArray) {
    let demo: any = [];
    let alreadySelected: any = this.selected;
    _.map(newArray, function (key, val) {
      newArray[val].checked = false;
      demo.push(newArray[val]);
    });
    if (alreadySelected.length > 0) {
      _.each(newArray, function (newkey, newval) {
        _.each(alreadySelected, function (key, val) {
          if (newArray[newval].id === alreadySelected[val].id) {
            newArray[newval].checked = true;
          }
        });
      });
    }
    this.filteredList = demo;
  }

  public change(event, item) {
    if (event.target.checked) {
      this.selected.push(item);
    } else {
      this.selected.splice(this.selected.indexOf(item), 1);
    }
  }

  public editorContent() {
    if (
      document.getElementsByClassName("ql-editor").length > 0 &&
      document.getElementsByClassName("ql-editor")[0].innerHTML != "<p><br></p>"
    ) {
      return true;
    }
    return false;
  }

  public getAnnouncementData() {
    
    if (
      this.allurl.length > 0 ||
      this.editorContent() || this.videoLink
    ) {
      if (this.getTextOrLinkData()) {
        return true;
      }
    } else {
      this.showButtonLoading = true;
      this.translate.get("fillToProceedAnnouncement").subscribe(msg => {
        this._toaster.showError(msg);
      });
      return true;
    }
    
    this.showButtonLoading = false;
  }

  public getTextOrLinkData() {
    let documentElement = document.getElementsByClassName("ql-editor")[0].innerHTML;
    if (documentElement.trim() != "") {
      if (documentElement.search("<img") != -1) {
        let innerText = document.getElementsByClassName("ql-editor")[0].children;
        this.announcementContent = [];
        for (let i = 0; i < innerText.length; i++) {
          let nodeText = innerText[i].childNodes;
          for (let j = 0; j < nodeText.length; j++) {
            if (nodeText[j].textContent !== '') {
              this.announcementContent.push(nodeText[j].textContent);
            }
          }
        }
        this.announcementData.textContent = this.announcementContent.toString();
      } else if (documentElement.search("iframe") != -1) {
        this.announcementData.textContent = documentElement.split("<iframe")[0];
      } else {
        this.announcementData.textContent = documentElement;
      }
      if (documentElement.search("<img") != -1 && documentElement.search("iframe") != -1) {
        if (documentElement.search("<img") != -1) {
          this.announcementData.textContent = documentElement.split("<img")[0];
        }
        if (this.announcementData.textContent.search("iframe") != -1) {
          this.announcementData.textContent = this.announcementData.textContent.split(
            "<iframe"
          )[0];
        }
      }
      return false;
    } else {
      this.translate.get("fillToProceedAnnouncement").subscribe(msg => {
        this._toaster.showError(msg);
      });
      return true;
    }
  }

  public triggerAnnouncement() {
    if (this.safe == true) {
      let self = this;
      this.buttonStatus = true;
      this.scheduleButton = true;
      let url = self._baseUrl + "v1/webAdmin/announcement/postAnnouncement";
      if (this.videoLink) {
        var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = this.videoLink.match(regExp);
        if (match && match[2].length == 11) {
          this.videoLink = "https://www.youtube.com/embed/" + match[2] + "?rel=0&modestbranding=1&autohide=1&autoplay=0"
        }
        this.announcementData.videoURL.push(this.videoLink);
      }
      if (this.announcementData.textContent.length > 5000) {
        this.translate.get("charLimitExceed").subscribe(msg => {
          this._toaster.showError(msg);
        });
        this.buttonStatus = false;
      }
      else if (this.announcementData.title.length > 500) {
        this.translate.get("titleLimitExceed").subscribe(msg => {
          this._toaster.showError(msg);
        });
        this.buttonStatus = false;
      } else {
        self.check(url).subscribe(result => {
            this.translate.get("announcementSuccessfull").subscribe(msg => {
              console.log(result);
              this._toaster.showSuccess(msg);
              this.buttonStatus = false;
              this.goToBackPage();
            });
            this.searchData.employeeCodes = [];
            this.searchData.excludedEmployeeCodes = [];

          }, error => {
            this.translate.get("errorWhileAnnouncement").subscribe(msg => {
              this._toaster.showError(msg);
            });
            setTimeout(() => self.goToBackPage(), 1000);
          }
        );
      }
    } else {
      this.translate.get("invalidVideoUrl").subscribe((msg: any) => {
        this._toaster.showError(msg);
      });
    }
  }

  public check(url): Observable<any> {
    let self = this;
    try {
      return Observable.create((observer: any) => {
        self.announcementData.triggerDtm = null;
        let obs = forkJoin([
          self.http.post(url, self.announcementData)
        ]);
        obs.subscribe((response: any) => {
          observer.next(response);
          observer.complete();
        });
      });
    } catch (e) {
      console.log("getAllEmployeeData error catch", e);
    }
  }

  public showAdvanced() {
    if (!this.getAnnouncementData()) {
      if (
        this.announcementData.title == null ||
        this.announcementData.title == ""
      ) {
        this.translate.get("enterMandatoryFields").subscribe(msg => {
          this._toaster.showError(msg);
        });
        return false;
      } else {
        this.share.saveAsMap("announcement", this.announcementData);
        this.share.saveAsMap("allurlImageData", this.allurl);
        this.share.saveAsMap("videoLink", this.videoLink);
        this.router.navigate(["menu/employeeSearch"]);
      }
    }
  }

  public showError(data) {
    let self = this;
    self._toaster.showError("Invalid input/employee codes : " + data[0]);
    self.buttonStatus = false;
    self.scheduleButton = false;
    self.announcementData.videoURL = [];
    self.announcementData.attachmentList = [];
  }

  public goToBackPage() {
    this.announcementData.title = null;
    this.announcementData.attachmentList = [];
    this.announcementData.textContent = null;
    this.announcementData.videoURL = [];
    this.videoLink = '';
    this.allurl = [];
    this.empCodeValues = "";
    if (document.getElementsByClassName("ql-editor").length != 0) {
      document.getElementsByClassName("ql-editor")[0].innerHTML = "<p><br></p>";
    }
    this.buttonStatus = false;
    this.scheduleButton = false;
    this.query = "";
    this.selected.length = 0;
    this.filteredList = [];
  }

  public scheduleAnnouncement(announcementData) {
    announcementData.employeeSearchFilter = this.searchData;
    this.share.saveData(announcementData);
    this.modalService.open(ScheduleAnnouncement).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
        if (result == "confirmed") {
          this.goToBackPage();
        }
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  public getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  public disableKey() {
    document.onkeydown = function (e) {
      return false;
    };
  }

  public enableKey() {
    document.onkeydown = function (e) {
      return true;
    };
  }

  public fileChange(event) {
    debugger
    const fileList: FileList = event.target.files;
    let result: any;
    if (fileList.length > 0) {
      let mimeType = fileList[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.translate.get("ImageInvalid").subscribe(msg => {
          this._toaster.showError(msg);
        });
        return;
      }

      const file: File = fileList[0];
      const reader = new FileReader();
      const fileName = file.name;
      const path = event.target.value;
      reader.onloadend = (e: any) => {
        result = e.target.result;
        this.getAllData(path, fileName, result);
      };
      reader.readAsBinaryString(file);
    }
  }

  public getAllData(path, fileName, result) {
    const ext = fileName.substring(fileName.lastIndexOf(".")+1, fileName.length);
    let attachmentJson = {
      docName: fileName,
      docType: ext,
      document: window.btoa(result)
    };
    this.announcementData.attachmentList.push(attachmentJson);
  }

  public readUrl(event: any) {
    console.log(event.target.files)
    if (event.target.files && event.target.files[0]) {
      let mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (ProgressEvent: ProgressEvent) => {
        this.url = (ProgressEvent.target as FileReader).result;
        this.allurl.push((ProgressEvent.target as FileReader).result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public deletepic(index) {
    this.announcementData.attachmentList.splice(index, 1);
    this.allurl.splice(index, 1);
  }

  public onBlurMethod(vid) {
    this.invalidURL = false;
    if (vid != undefined) {
      var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (!vid.match(p)) {
        this.videoLink = '';
        this.invalidURL = true;
        this.translate.get("invalidVideoUrl").subscribe(msg => {
          this._toaster.showError(msg);
        });
        return false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/programManagement/announcements/announcements.ts